<template>
  <AppButton
    v-ripple="false"
    :class="{ 'no-hover': !hasHover}"
    :flat="flat"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <div
      v-if="count || count === 0"
      class="q-ml-sm"
    >
      <q-badge
        :label="count"
        class="text-10-700"
        color="primary"
        rounded
      />
    </div>
    <slot/>
  </AppButton>
</template>

<script>
import AppButton from 'common/components/buttons/AppButton';

export default {
  name: 'AppButtonLink',
  components: { AppButton },
  props: {
    flat: {
      type: Boolean,
      default: true,
    },
    count: {
      type: [Number, String],
      default: undefined,
    },
    hasHover: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.q-btn {
  transition: 450ms ease all;

  &:not(.no-hover):hover {
    color: $primary;

    ::v-deep .q-separator {
      background-color: $primary !important;
    }
  }

  ::v-deep .on-right {
    margin-left: 4px;
  }

  ::v-deep {
    .q-btn__wrapper,
    .q-btn__content span {
    }
  }

  font-weight: 400;
}
</style>
